import type { RelationshipRowVM } from '@/lib/relationships/relationships.types';

/**
 * Persona lists derived from `myRelationships` (ENT-89 handover §4 table).
 * These are pure filters over the shipped `RelationshipRowVM[]` — the data
 * layer (useMyRelationships + mapper) is reused from ENT-88.
 */

/**
 * Agency → the clients it manages. The platform (SA) `MANAGES` BOTH agencies and
 * clients, so we exclude agencies here (T08) — anything not an AGENCY (clients +
 * unresolved-persona orgs) counts as a client. For a non-platform context this
 * is a no-op (an agency doesn't manage other agencies).
 */
export const selectMyClients = (rows: RelationshipRowVM[]) =>
  rows.filter(
    (r) => r.direction === 'SOURCE' && r.kind === 'MANAGES' && r.counterparty.persona !== 'AGENCY',
  );

/** Platform (SA) → the agencies it oversees (T08). */
export const selectAgencies = (rows: RelationshipRowVM[]) =>
  rows.filter(
    (r) => r.direction === 'SOURCE' && r.kind === 'MANAGES' && r.counterparty.persona === 'AGENCY',
  );

/** Client (or anyone) → vendors serving me (identity-only, no scope leaked). */
export const selectMyVendors = (rows: RelationshipRowVM[]) =>
  rows.filter((r) => r.direction === 'TARGET' && r.kind === 'PROVIDES_SERVICE');

/** Vendor → the customers it serves (service-scoped). */
export const selectWhoIServe = (rows: RelationshipRowVM[]) =>
  rows.filter((r) => r.direction === 'SOURCE' && r.kind === 'PROVIDES_SERVICE');

/** EOR/AOR placements either direction. */
export const selectEorAorPlacements = (rows: RelationshipRowVM[]) =>
  rows.filter((r) => r.kind === 'EOR_PLACEMENT' || r.kind === 'AOR_PLACEMENT');
